<template>
  <el-container>
    <el-main class="main">
      <span>配置列表</span>
      <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="toSaleOrgConfigAdd">添加配置</el-button>
      <el-divider></el-divider>
      <el-table :data="tableList" border style="margin-top: 20px">
        <el-table-column label="销售组织">
          <template slot-scope="scope">
            {{scope.row.orgSales[0].name}}
          </template>
        </el-table-column>
        <el-table-column label="业务员订货展示价格" prop="isPricePer" :formatter="formatValue"></el-table-column>
        <el-table-column label="客户订货展示价格" prop="isPriceCus" :formatter="formatValue"></el-table-column>
        <el-table-column label="销量查询展示辅助数量" prop="isShowAssist" :formatter="formatValue"></el-table-column>
        <el-table-column label="销量查询展示金额" prop="isShowAmount" :formatter="formatValue"></el-table-column>、
        <el-table-column label="订单天数（可查询几天前的订单）" prop="orderDay"></el-table-column>
        <el-table-column label="提货天数（可预约几天后的提货单）" prop="deliveryDay"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="修改时间" prop="updateTime"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="toSaleOrgConfigEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteById(scope.row.id)" :loading="loading">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import {mapGetters} from "vuex";
import {deleteBasEbusinessByIds, queryBasEbusinessPageList} from "../../../../api/system/saleOrgConfig";
import {getOrgByAdmin} from "../../../../api/system/org_sale";

export default {
  name: "index",
  data(){
    return{
      tableList:[],
      loading:false
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getOrgByAdmin()
  },
  methods: {
    formatValue(row, column, cellValue, index) {
      return cellValue === 1 ? '是' : '否';
    },
    getList(){
      let param = {}
      param.orgSales = this.saleOrgLists
      queryBasEbusinessPageList(param).then(res => {
        this.tableList = res.data.records
        console.log(this.tableList)
      }).catch(err=>{
        console.log(err)
      })
    },
    getOrgByAdmin(){
      let param = {'id':this.currentUser.id}
      getOrgByAdmin(param).then(res => {
        console.log(res.data)
        this.saleOrgLists = res.data
        this.getList();
      }).catch(()=>{

      })
    },
    deleteById(id){
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = []
        param.push(id)
        this.loading = true
        deleteBasEbusinessByIds(param).then(res => {
          if(res.code === 200){
            this.$modal.msgSuccess("删除成功！");
            this.loading = false
            this.getList()
          }else{
            this.$modal.msgError("删除失败，请重试");
            this.loading = false
          }
        }).catch(()=>{
          this.loading = false
        });
      }).catch(() => {
        this.$modal.msg("已取消删除");
        this.loading = false
      });
    },
    toSaleOrgConfigAdd() {
      this.$router.push({path: "/saleOrgConfigAdd"});
    },
    toSaleOrgConfigEdit(saleOrgConfigList) {
      this.$router.push({name: "SaleOrgConfigAdd",params:{'saleOrgConfigList':JSON.stringify(saleOrgConfigList)}});
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 90vh;
  }
</style>
